var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRating = function SvgRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "M7.203 20H7.2a.2.2 0 0 1-.107-.032.28.28 0 0 1-.1-.247l.002-.01v-.01l.438-4.923.037-.416-.27-.319-3.132-3.698v-.001a.29.29 0 0 1-.052-.276l.003-.008.002-.008a.24.24 0 0 1 .17-.159l4.57-1.082.422-.1.216-.377 2.398-4.207.005-.009A.23.23 0 0 1 12 4a.23.23 0 0 1 .2.118l.003.006L14.6 8.361l.215.38.425.1 4.568 1.082a.23.23 0 0 1 .17.16l.003.007.003.008a.29.29 0 0 1-.05.276l-.002.001-3.114 3.667-.27.32.037.416.437 4.922v.005a.28.28 0 0 1-.115.254l-.003.003a.2.2 0 0 1-.198.02l-.002-.001-4.298-1.947-.413-.187-.413.187-4.293 1.947-.002.001a.2.2 0 0 1-.083.018Z"
  })));
};
export default SvgRating;